/* global G */

/**
 * Initializes the PubSpub connection
 *
 * TODO: This is currently hardcoded for messages, generalize it
 *
 * @param {Gaia.Web.Application|Gaia.AppModule.Spec} obj the platform Application
 * @returns {function(*): *}
 */
const init = obj => (args) => {
  const meta = obj?.[G.SESSION]?.[G.STATE]?.[G.META]
    || obj?.[G.ADAPTER]?.[G.SESSION]?.[G.STATE]?.[G.META]

  const { subscription = {} } = meta?.role || {}
  const roomNames = Object.keys(subscription).filter(room => subscription[room])

  meta && obj[G.ADAPTER][G.EVENTS].dispatch(
    obj[G.ADAPTER][G.EVENTS].type(G.DATA, G.INIT), {
      [G.DATA]: meta?.refs?.user?.[0],
      // callback function that gets all global room names passed as the rooms object
      // parameter and expects an object containing just those we want to subscribe to
      [G.PUBSUB]: rooms => Object.keys(rooms)
        .filter(roomName => roomNames.includes(roomName))
        .reduce((acc, roomName) => {
          acc[roomName] = rooms[roomName]
          return acc
        }, {}),
    },
  )

  return args
}

export default init
